

let map = {
};

let sequence = 0;

let listeners = [];

function notifyListeners(entityName) {
	listeners.forEach(lst => {
		lst(entityName);
	});
}

export function getEntityTimestamp(entityName) {
	return map[entityName] || 0;
}

export function updateEntityTimestamp(entityName) {
	map[entityName] = ++sequence;
	try {
		if (window.opener && window.opener._pg_updateEntityTimestamp) {
			window.opener._pg_updateEntityTimestamp(entityName);
		}
	} catch (ex) {
	}
	notifyListeners(entityName);
}


export function addEntityTimestampListener(lst) {
	listeners.push(lst);
}

export function removeEntityTimestampListener(lst) {
	listeners = listeners.filter(ex => ex !== lst);
}

window._pg_updateEntityTimestamp = updateEntityTimestamp;
